export const getEstPrice = function(params) {
    if (window?.sitePageAutoInit === false) {
        return import(
            /* webpackChunkName: "sold_estimate_mock"*/ './cms-mock'
        ).then(res => {
            //  right   result in a deep copy
            return Promise.resolve(JSON.parse(JSON.stringify(res)));
        });
    }
    return this.axiosIns.get('/api-site/evaluation/address', { params });
};
export const getMedianPrice = function(params) {
    if (window?.sitePageAutoInit === false) {
        return import(
            /* webpackChunkName: "sold_estimate_mock"*/ './cms-mock'
        ).then(res => {
            //  right   result in a deep copy
            return Promise.resolve(JSON.parse(JSON.stringify(res)));
        });
    }
    return this.axiosIns.get('/api-site/snapshot/listings', { params });
};
export default {
    getEstPrice: getEstPrice,
    getMedianPrice: getMedianPrice
};
